import Vue from 'vue';
import search from './search/search';
Vue.component('search-app', search);
